<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";

export interface DataCellInfoDialogProps {
  infoToDisplay: string;
}
export interface DataCellInfoDialogEvents extends DialogEvents {}

defineProps<DataCellInfoDialogProps>();
const emit = defineEmits<DataCellInfoDialogEvents>();

const { accept, cancel } = useReactiveDialogScriptSetup(emit);
</script>

<template>
  <bm-dialog v-bind="$attrs" @accept="accept" @cancel="cancel">
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="(text, index) in infoToDisplay.split('\n')"
          :key="index"
          cols="12"
        >
          {{ text }}
        </v-col>
      </v-row>
    </v-container>
    <template #controls-cancel-text>
      {{ $m.cancel }}
    </template>
    <template #controls-confirm-text>
      {{ $m.ok }}
    </template>
  </bm-dialog>
</template>
